import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IStatusLabelProps extends ITranslateProps {
    value?: undefined | string;
}

class BatchStatusLabelComponent extends React.Component<IStatusLabelProps, Record<string, unknown>> {
    public override render() {
        if (!this.props.value) {
            return null;
        }
        // let name = codeToName(this.props.value);
        const text = this.props.t(`batchStatus.${this.props.value}`);
        return (
            <span className={`label ${this.statusToClassname(this.props.value)}`} title={text}>
                {text}
            </span>
        );
    }

    private statusToClassname(status: string) {
        switch (status) {
            case 'completed':
                return 'label-success';
            case 'active':
                return 'label-warning';
            case 'open':
                return 'label-info';
            case 'deleted':
                return 'label-muted';
            default:
                return 'label-info';
        }
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const BatchStatusLabel = translate()(BatchStatusLabelComponent);
export { BatchStatusLabel };
